import Http from "@/api/http";
import {
  defaultHeader,
  handleUrlBody,
  responseDataDecode,
  handleResponseHeaders,
  responseToError
} from "../interceptors";
// 实例化http方法
const http = new Http({});
export default http;

/**
 * 添加默认的header
 * 对于私有api，需要设置默认的headers，需要在extral里设置 default_headers 为true
 */
http.interceptors.request.use(
  async (config: any) => await defaultHeader(config),
  error => Promise.reject(error)
);

/**
 * 处理get方法的url与post方法的body
 */
http.interceptors.request.use(
  config => handleUrlBody(config),
  error => Promise.reject(error)
);

/**
 * 对返回结果解密
 */
http.interceptors.response.use(
  res => responseDataDecode(res),
  error => Promise.reject(error)
);

/**
 * 处理返回的header
 */
http.interceptors.response.use(
  res => handleResponseHeaders(res),
  error => Promise.reject(error)
);

/**
 * 根据返回结果，处理错误
 * 对于非登录的私有api，需要处理lgoin_required  challenge_required feedback_required这几种情况
 * 设置extra_data.error_handle 为true
 */

http.interceptors.response.use(
  res => responseToError(res),
  error => Promise.reject(error)
);
